export default "__VITE_ASSET__Khdlpu38__"